import React from 'react';
import axios from 'axios';

const api = axios.create({
  // baseURL: "https://dev.amplofly-aws.com/api",
  baseURL: 'https://nodebackend-demo.amplofly-aws.com/api',
  // baseURL: 'http://localhost:5001/api',
  // baseURL: `/api`,
  timeout: 30000, // Add timeout
});

export default api;
